class PlannerApplication {

    constructor(plannerType) {
        this.plannerType = plannerType;
        this.controllers = {};
        this.appName = this.constructor.name;
        this.config = getPlannerConfiguration();
        this.api = this.createAPIService();
        this.data = this.createData();
        this.isReady = false;
        this.restoreGuid = getURLParameter('restore');
    }

    /** -------- initialisation & startup --------------- */

    startup() {
        this.api.fetchUniversityData(this.loadUniversityData.bind(this))
    }

    loadUniversityData(data) {
        this.data.load(data);
        this.cookiesEnabled = !this.data.university.disableCookies();
        appLogObject(this.appName, 'config', this.config);
        appLogObject(this.appName, 'data', this.data);
        this.readyToLoadProfile();
    }

    readyToLoadProfile() {
        if (this.loadYourProfile()) {
            this.ready();
        }
    }

    ready() {
        this.controllers.navigationContoller = new NavigationController();
        this.loadControllers();
        let effectsContentChangedFn =
            this.controllers.navigationContoller.navContentsResized.bind(this.controllers.navigationContoller.navContentsResized);
        this.controllers.dependencyController = new DependencyController();
        this.controllers.exclusiveCheckboxesController = new ExclusiveCheckboxesController();
        this.liveSessionManager = new PlannerLiveSessionManager(this);
        this.isReady = true;


        this.restoredYourProfile();
        if (this.yourProfile.getCurrentSection() !== 0) {
            setTimeout(function () {
                $('body').addClass('slidestart');
                this.controllers.navigationContoller.slickController.slick('slickGoTo', this.yourProfile.getCurrentSection());
                this.controllers.plannerHomeController.ready();
            }.bind(this), 800);
        } else {
            this.controllers.plannerHomeController.ready();
        }
    }

    loadYourProfile() {
        if (this.config.debugPersistData) {
            this.yourProfile = this.#debugRestoreUserData();
            return true;
        } else if (this.restoreGuid !== null) {
            this.api.loadProfile(this.restoreGuid, function (userData) {
                appLogObject('PlannerApp', 'userData', userData);
                this.yourProfile = this.createYourProfileFromUserData(userData);
                this.ready();
            }.bind(this));
            return false;
        } else {
            this.yourProfile = this.createYourProfile();
            return true;
        }
    }

    restoredYourProfile() {
        $('.hide-on-share').hideIf(this.yourProfile.isSharedPlan());

        if(this.yourProfile.getSelectedCourse() !== null) {
            let groupName = this.yourProfile.getSelectedCourse().getGroupName();
            let group = this.data.courseGroups.findWhere({'name':groupName});
            if(group !== undefined) {
                this.yourProfile.setCourseGroupModel(group);
            }
            this.controllers.plannerCourseGroupController.selectCourseGroup();
            this.controllers.plannerCourseController.onCourseSelected();
            this.controllers.plannerCourseController.updateGroupSelection(this.yourProfile.getSelectedCourseGroup());
        }
    }

    loadControllers() {
        this.controllers.plannerHomeController = new PlannerHomeController();
        this.controllers.yourDetails = new PlannerYourDetailsController();
        this.controllers.plannerCourseGroupController = new PlannerCourseGroupSelectionController();
        this.controllers.plannerCourseController = new PlannerCourseSelectionController();
    }

    userDataUpdated() {
        if (this.config.debugPersistData) {
            this.needsUserDataUpdate = true;
            setTimeout(function () {
                this.#debugPersistUserData();
            }.bind(this), 3000);
        }
    }

    courseSelectionChanged() {

    }

    createAPIService() {
        return new PlannerAPIService(this.config);
    }

    createData() {
        return new PlannerData();
    }

    createYourProfile() {
        return new PlannerYourProfile();
    }

    getYourProfile() {
        return this.yourProfile;
    }

    getUserData(forDebug) {
        return this.yourProfile;
    }

    createYourProfileFromUserData(userData) {
        return new PlannerYourProfile(userData);
    }

    screenSizeDidChange() {
        this.controllers.navigationContoller.navContentsResized();
    }

    /** -------- utilities --------------- */
    movedToSection(sectionNo) {
        this.yourProfile.setCurrentSection(sectionNo);
        this.userDataUpdated();
        appLogAttr(this.appName, 'sectionNo', sectionNo);
    }

    /** -------- private methods --------------- */

    #debugPersistUserData() {
        if (!this.needsUserDataUpdate) {
            return;
        }
        this.needsUserDataUpdate = false;

        let json = storeModelInCookie(this.getUserData(true), this.appName + '__debugPersistUserData_' + this.config.brand);
        appLogObject(this.appName, 'debugPersistUserData', json);
    }

    #debugRestoreUserData() {
        let userData = restoreJSONFromCookie(this.appName + '__debugPersistUserData_' + this.config.brand);
        if (userData != null) {
            return this.createYourProfileFromUserData(userData);
        }
        return this.createYourProfile();
    }
}

let plannerApplication = null;
$().ready(function () {
    plannerApplication = createPlannerApp();
    plannerApplication.startup();
});
